/**
 * @file getRawCookieByName
 * @description Utility function to retrieve a raw cookie by its name from a string of cookies.
 * @param {string} rawCookies - The string containing all cookies.
 * @param {string} cookieName - The name of the cookie to retrieve.
 * @returns {Object|null} An object containing the raw cookie, its name, value,
 * and input string, or null if not found.
 */
export const getRawCookieByName = (rawCookies, cookieName) => {
  const match = String(rawCookies).match(
    new RegExp(
      `(?:^|[;,]) *(${// capture only the cookie name-value pair
        String(cookieName).replace(/[\s#$()*+,.?[\\\]^{|}-]/g, '\\$&')
      }=([^;]*)`
      + ')'
    )
  );
  return Array.isArray(match)
    ? {
      raw: match[1], // the matched cookie name-value pair, without leading ;
      name: cookieName,
      value: decodeURIComponent(match[2]),
      input: match.input,
    }
    : null;
};
